import * as HttpService from "../services/common-services/HttpService";

export function register(UserData) {
  return HttpService.postWithoutAuth("api/v1/Register", UserData);
}
